<template>
  <div class="container">
    <Header />

    <MapTitle :curTab="1" :data="mapTitleData" @getCurTab="setCurtab" />
    <AmapTransfermap :chartData="MapData" :legendColor="legendColor" v-if="!mapMode && MapData" />
    <div id="smallMap2" v-show="mapMode"></div>

    <div class="left-content">
      <BScroll>
        <div>
          <BasePanel title="7月游客量概况">
            <YoukeliangGaikuang :chartData="YoukeliangGaikuangData" v-if="YoukeliangGaikuangData" />
          </BasePanel>
          <div class="small-map">
            <div @click="mapMode=!mapMode" class="switch"></div>
            <div id="smallMap" v-show="!mapMode"></div>
            <AmapTransfermap :chartData="MapData" :legendColor="legendColor" :zoom="4" id="transferMap2" v-if="mapMode && MapData" />
          </div>
          <BasePanel title="游客来源分析">
            <YoukeLaiyuanFenxi :chartData="youkelaiyuanData" v-if="youkelaiyuanData.length > 0" />
          </BasePanel>
        </div>
      </BScroll>
    </div>
    <div class="right-content">
      <BScroll>
        <div>
          <BasePanel title="游客群体画像">
            <YoukeQuntiHuaxiang />
          </BasePanel>
          <BasePanel title="游客线下行为分析">
            <YoukeXianxiaXingweiFenxi />
          </BasePanel>
          <BasePanel title="游客线上行为分析">
            <YoukeXianshangXingweiFenxi />
          </BasePanel>
        </div>
      </BScroll>
    </div>
    <div :class="['center-top-content', 'click-chuantou']" class="center-top-content"></div>
    <div class="center-bottom-content">
      <HomeBottomBar :chartData="homebottombarData" id="homeBottomBar" v-if="homebottombarData" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Common/Header.vue'
import MapTitle from '@/components/Common/MapTitle.vue'
import BasePanel from '@/components/Common/BasePanel.vue'
import YoukeliangGaikuang from '@/components/Home/YoukeliangGaikuang.vue'
import YoukeLaiyuanFenxi from '@/components/Home/YoukeLaiyuanFenxi.vue'
import YoukeXianshangXingweiFenxi from '@/components/Home/YoukeXianshangXingweiFenxi.vue'
import YoukeXianxiaXingweiFenxi from '@/components/Home/YoukeXianxiaXingweiFenxi.vue'
import YoukeQuntiHuaxiang from '@/components/Home/YoukeQuntiHuaxiang.vue'
import HomeBottomBar from '@/components/Echarts/HomeBottomBar.vue'
import AmapTransfermap from '@/components/Echarts/AmapTransfermap.vue'

import BScroll from '@/components/Common/BScroll.vue'

export default {
  name: 'SpotPasttime',
  components: {
    Header,
    MapTitle,
    BasePanel,
    YoukeliangGaikuang,
    YoukeLaiyuanFenxi,
    YoukeXianshangXingweiFenxi,
    YoukeXianxiaXingweiFenxi,
    YoukeQuntiHuaxiang,
    HomeBottomBar,
    BScroll,
    AmapTransfermap
  },
  data() {
    return {
      mapTitleData: {
        title: '',
        tab: ['实时', '历史']
      },
      MapData: null,
      legendColor: ['#DA221A', '#FF852F', '#F5E047', '#6BF15c', '#34B7ED'],
      YoukeliangGaikuangData: null,
      youkelaiyuanData: [],
      homebottombarData: null,
      map: null,
      mapMode: false
    }
  },
  mounted() {
    // 请求地图数据
    fetch('/data/SpotPasttime/YoukeLaiyuanDetail.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.MapData = json.data
        this.mapTitleData.title = json.data.title
        this.map = new AMap.Map('smallMap', {
          mapStyle: 'amap://styles/b5500447492ee5d38f79824b6e68aec4',
          center: this.MapData.curCenter,
          zoom: 12
        })
        this.map = new AMap.Map('smallMap2', {
          mapStyle: 'amap://styles/b5500447492ee5d38f79824b6e68aec4',
          center: this.MapData.curCenter,
          zoom: 12
        })
      })
    // 请求游客量概况
    fetch('/data/SpotPasttime/YoukeliangGaikuang.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.YoukeliangGaikuangData = json.data
      })
    // 请求游客来源
    fetch('/data/SpotPasttime/YoukeLaiyuan.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.youkelaiyuanData = json.data
      })
    // 请求底部图表
    fetch('/data/SpotPasttime/HomeBottomBar.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.homebottombarData = json.data
      })
  },
  methods: {
    setCurtab(val) {
      if (val == 0) {
        this.$router.push({ path: '/spotrealtime' })
      }
    }
  }
}
</script>
<style scoped lang="less">
.center-content {
  width: 56%;
  height: 89%;
  max-height: 1080px;
  position: absolute;
  top: 1.04rem;
  left: 50%;
  transform: translateX(-50%);
  .center-top-content {
    width: 100%;
    height: 78%;
    position: relative;
  }
  .center-bottom-content {
    width: 100%;
    height: 22%;
  }
}
.center-top-content {
  width: 56%;
  height: 65%;
  position: relative;
  margin: 0 auto;
}
.center-bottom-content {
  width: 56%;
  height: 22%;
  margin: 0 auto;
}
.click-chuantou {
  pointer-events: none;
}
.small-map {
  width: 100%;
  height: 2.34rem;
  border: 1px solid #00cdff;
  margin: 0.6rem 0 0.5rem;
  position: relative;
  .switch {
    width: 0.22rem;
    height: 0.23rem;
    background: url(../assets/open.png);
    position: absolute;
    top: 0.06rem;
    right: 0.12rem;
    z-index: 99;
    cursor: pointer;
  }
  #smallMap {
    width: 100%;
    height: 100%;
    background: #16222f;
  }
}
#smallMap2 {
  width: 100%;
  height: 100%;
  background: #16222f;
  position: absolute;
  left: 0;
  top: 0;
}
</style>
